module.exports = __webpack_public_path__ + "static/media/landingpage.641fb45d.gif";